var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUnassignedPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_20",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "#00BCE7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_20)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 16.5V19.9394L20.6894 16.5H17.25ZM15.75 15.75C15.75 15.3358 16.0858 15 16.5 15H22.5C22.8034 15 23.0768 15.1827 23.1929 15.463C23.309 15.7433 23.2448 16.0658 23.0303 16.2803L17.0303 22.2803C16.8158 22.4948 16.4933 22.559 16.213 22.4429C15.9327 22.3268 15.75 22.0534 15.75 21.75V15.75Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.5V5H20.25V6.5H8.25Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.25V9.75H20.25V8.25H8.25Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8067 15.746C4.5138 15.4531 4.03893 15.4531 3.74604 15.746C3.45315 16.0389 3.45314 16.5138 3.74604 16.8067L5.6022 18.6629C5.74284 18.8035 6.61038 19.671 6.85843 19.9191L7.28707 20.3477C7.43851 20.4992 7.90029 20.6074 8.25385 20.2538C8.6074 19.9003 8.54617 19.4855 8.30074 19.2401C8.30074 19.2401 7.94318 18.8825 6.44319 17.3825C5.8041 16.7434 4.8067 15.746 4.8067 15.746Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74604 19.1932C3.45314 19.4861 3.45315 19.961 3.74604 20.2538C4.03893 20.5467 4.5138 20.5468 4.8067 20.2538L6.66285 18.3977C6.8035 18.2571 7.67103 17.3895 7.91909 17.1415L8.34773 16.7128C8.49917 16.5614 8.6074 16.0996 8.25384 15.746C7.90029 15.3925 7.48551 15.4537 7.24007 15.6992C7.24007 15.6992 6.88252 16.0567 5.38253 17.5567C4.74344 18.1958 3.74604 19.1932 3.74604 19.1932Z",
    fill: "#00BCE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 2.25C5.25 1.00736 6.25736 0 7.5 0H21C22.2427 0 23.25 1.00736 23.25 2.25V15.75C23.25 15.9489 23.1709 16.1397 23.0303 16.2803L17.0303 22.2803C16.8897 22.4209 16.6989 22.5 16.5 22.5H9.9687C8.91105 23.4335 7.52167 24 6 24C2.68629 24 0 21.3137 0 18C0 14.9403 2.29027 12.4155 5.25 12.0464V2.25ZM16.1894 21H11.1973C11.7078 20.1175 12 19.0928 12 18C12 14.9403 9.70973 12.4155 6.75 12.0464V2.25C6.75 1.83579 7.08579 1.5 7.5 1.5H21C21.4142 1.5 21.75 1.83578 21.75 2.25V15.4394L16.1894 21ZM6 13.5C3.51472 13.5 1.5 15.5147 1.5 18C1.5 20.4853 3.51472 22.5 6 22.5C8.48527 22.5 10.5 20.4853 10.5 18C10.5 15.5147 8.48527 13.5 6 13.5Z",
    fill: "#00BCE7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#00BCE7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnassignedPrimary);
export default __webpack_public_path__ + "static/media/ic-unassigned-primary.76423bd556f6b7041bda1efdcb417adf.svg";
export { ForwardRef as ReactComponent };